import { zodSchemes } from '@approvalmax/utils';
import { CountryIsoCode } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

const companyAddressSchema = z.object({
    street: zodSchemes.required.textField.string(),
    buildingNumber: zodSchemes.required.textField.string(),
    apartmentNumber: zodSchemes.optional.textField.string.nullable(),
    buildingName: zodSchemes.required.textField.string(),
    state: zodSchemes.optional.textField.string.nullable(),
    city: zodSchemes.required.textField.string(),
    postalCode: zodSchemes.required.textField.string(),
    country: zodSchemes.required.select.enum(CountryIsoCode),
});

const baseSchema = z.object({
    registeredAddress: companyAddressSchema,
});

const addressesAreEqualSchema = baseSchema.extend({
    areCompanyAddressesEqual: z.literal(true),
});

const addressesAreNotEqualSchema = baseSchema.extend({
    areCompanyAddressesEqual: z.literal(false),
    tradingAddress: companyAddressSchema,
});

export const businessInformationSchema = z.discriminatedUnion('areCompanyAddressesEqual', [
    addressesAreEqualSchema.passthrough(),
    addressesAreNotEqualSchema.passthrough(),
]);

export const schema = z
    .object({
        businessInformation: businessInformationSchema,
    })
    .passthrough();
